import { setBrowserSessionData } from '@/utils/browser-storage';


export function setUser(state, payload) {
    state.user = payload;
}

export function setUserLocationAddress(state, payload) {
    state.userLocationAddress = payload;
}

export function setUserLocation(state, payload) {
    state.userLocation = payload
}

export function setUserCoordinates(state, payload) {
    state.userCoordinates = payload;
}

export function setOpenPOIAfterLogin(state, payload) {
    state.openPOIAfterLogin = payload
}

export function setSessionData(state, payload) {
    state.sessionData = payload
    setBrowserSessionData('refrToken', payload.refresh_token)
}